import { render } from "./LazyBaseInputText.vue?vue&type=template&id=67bcfc77&scoped=true"
import script from "./LazyBaseInputText.vue?vue&type=script&lang=ts"
export * from "./LazyBaseInputText.vue?vue&type=script&lang=ts"

import "./LazyBaseInputText.vue?vue&type=style&index=0&id=67bcfc77&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67bcfc77"

export default script